export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-refresher/index.js